import { Route } from "@angular/router";
import { SignInUsernameComponent } from "../components/sign-in-username/sign-in-username.component";
import { SignInPasswordComponent } from "../components/sign-in-password/sign-in-password.component";
import { SignInForgottenPasswordComponent } from "../components/sign-in-forgotten-password/sign-in-forgotten-password.component";
import { SignInDetailsResolver } from "../resolvers/sign-in-details.resolver";
import { SignInRouteDataGuard } from "./sign-in-route-data.guard";
import { SignInRootGuard } from "./sign-in-root.guard";
import * as signInRoutes from './route-locales/sign-in-routes';
import { StrapiResolver } from "@nx/strapi";
import { ReferrerPageCheckResolver } from "../resolvers/referrer-page-check.resolver";
import { UserSignedInGuard } from "../../common/routing/user-signed-in.guard";

export const signInUsernameState: Route = {
  path: signInRoutes.signInUsernameState.path,
  data: {
    title: signInRoutes.signInUsernameState.title,
    strapiUrl: "sign-in?populate[username][populate]=*"
  },
  component: SignInUsernameComponent,
  resolve: {
    signInDetails: SignInDetailsResolver,
    signInCmsData: StrapiResolver,
    enteredFromReferrerPage: ReferrerPageCheckResolver
  }
};

export const signInPasswordState: Route = {
  path: signInRoutes.signInPasswordState.path,
  data: {
    title: signInRoutes.signInPasswordState.title,
    strapiUrl: "sign-in?populate[password][populate]=*"
  },
  component: SignInPasswordComponent,
  canActivate: [SignInRouteDataGuard],
  resolve: {
    signInDetails: SignInDetailsResolver,
    signInCmsData: StrapiResolver
  }
};

export const signInForgottenPasswordState: Route = {
  path: signInRoutes.signInForgottenPasswordState.path,
  data: {
    title: signInRoutes.signInForgottenPasswordState.title,
    strapiUrl: "forgotten-password?populate[newPassword][populate]=*&populate[verificationSlider][populate]=*&populate[tooManyCodeRequestsError][populate]=*&populate[inputCodeIncorrectlyTooManyTimesError][populate]=*&populate[incorrectCodeErrorHelp][populate]=*"
  },
  component: SignInForgottenPasswordComponent,
  canActivate: [SignInRouteDataGuard],
  resolve: {
    signInDetails: SignInDetailsResolver,
    cmsData: StrapiResolver
  }
};

export const signInRedirectState: Route = {
  path: '',
  pathMatch: 'full',
  redirectTo: signInRoutes.signInUsernameState.path
};

export const childRoutesState: Route = {
  path: '',
  children: [
    signInRedirectState,
    signInUsernameState,
    signInPasswordState,
    signInForgottenPasswordState
  ]
};

export const signInRootState: Route = {
  path: '',
  canDeactivate: [SignInRootGuard],
  canActivate: [UserSignedInGuard, SignInRootGuard],
  children: [
    childRoutesState
  ]
};

export const SignInStates = [signInRootState]